// トップページのセクションの「さらに見る」という機能
var revealCount = $('body').hasClass('home') ? 4 : 8;
var $loadButtons;

if ($('body').hasClass('home')) {
  $loadButtons = $('.swiper-slide:not(.swiper-slide-duplicate) .append__load-button');
} else {
  $loadButtons = $('.append__load-button');
}

$loadButtons.on('click', loadHiddenItems);

function loadHiddenItems(event, target) {
  var $clickedButton = typeof target !== 'undefined' ? $(target) : $(this); // クリックしたボタン
  var $clickedCategory = $clickedButton.closest('.append'); // 一番近い「append」という親要素
  var $hiddenItems = $clickedCategory.find('.append__item--hidden'); // 「sub」内にある「hidden」の要素

  if ($('body').hasClass('home')) {
    var currentTag =  $clickedCategory.data('tag');
    var currentLastItem = $clickedCategory.find('.append__item').get().pop();
    var currentIndex = $(currentLastItem).index() + 1;

    return $.ajax({
      type: 'GET',
      url: 'https://www.himeji-mitai.com/json/' + currentTag + '.json',
      dataType: 'json',
      success: function (data) {
        var totalArticleCount = data.length; // 今読み込んでいるJSONファイルの中の項目の合計

        for (var i = 0; i < revealCount; i += 1) { // 4つずつを表す
          if ((i + currentIndex + 1) <= totalArticleCount) { // 合計以上（存在しないもの）を読み込まないため
            var currentItem = data[currentIndex + i]; // 読み込み中の項目
            
            var today = new Date();
            var itemDate = new Date(currentItem.date);
            var dataDate = 'data-date="' + currentItem.date + '"';

            var dataRibbon = '';
            if (numDaysBetween(today, itemDate) < 7) {
              dataRibbon = 'data-ribbon="new"';
            } else if (currentItem.type === 'event') {
              dataRibbon = 'data-ribbon="event"';
            }

            var dataLocation = '';
            if (currentItem.location) {
              dataLocation = 'data-location="' + currentItem.location + '"';
            }

            var tags = ''; // HTMLに挿入するタグリスト

            if (currentItem.tags) {
              tags = '<ul class="append__item-tags">';

              currentItem.tags.forEach(function (tag) {
                tags += '<li class="append__item-tag">' +
                  '<a class="append__item-tag-link" href="/tag/index.html?tags=%25' + tag + '%25&sortBy=dates">' +
                    tag +
                  '</a>' +
                '</li>';
              });
              tags += '</ul>';
            }

            var emptyItem = '' +
            '<article class="append__item col-6 col-md-4 col-xl-3 mb-md-0 mx-auto px-1"' +
            dataRibbon +
            dataDate +
            'style="display: none;">' +
              '<div class="append__item-visual-wrap">' +
                '<div class="aspect append__item-visual" data-ratio="4:3">' +
                  '<div class="aspect__content squircle zoom">' +
                    '<a class="append__item-link" href="' + currentItem.permalink + '"' + dataLocation + '>' +
                      '<img class="lazyload" data-src="' + currentItem.image + '">' +
                    '</a>' +
                  '</div>' +
                '</div>' +
              '</div>' +
              tags +
              '<div class="append__item-text-wrap">' +
                '<a class="append__item-text-link" href="#append-item">' +
                  '<h4 class="append__item-text append__item-text--subtitle text-center">' +
                    currentItem.subtitle +
                  '</h4>' +
                  '<h3 class="append__item-text append__item-text--title">' +
                    currentItem.title +
                  '</h3>' +
                '</a>' +
              '</div>' +
            '</article>';

            $clickedCategory
              .find('.append__load-wrap')
              .before(emptyItem)
                .promise()
                .then(function() {
                  $(this).prevAll('article.append__item[style="display: none;"]').fadeIn();
                  tabbyBottom.updateAutoHeight(500);
                });
            } else {
              $clickedButton.css('opacity', '0')
            }
          } // for loop

          // AJAXからもっと記事を読み込むと親要素の高さが変わるため、
          // 固定になっている要素の高さの更新が必要となる
          setTimeout(function() {
            if (tabbySticky) tabbySticky.update();
            if (tabMenuSticky) tabMenuSticky.update();
          }, 500);
      },
      error: function (jqXHR, exception) {
        var msg = 'AJAX エラー！' + this.url + '\n';
        if (jqXHR.status === 0) {
          msg += 'ファイルが存在しない・接続できない [0]';
        } else if (jqXHR.status == 404) {
          msg += 'ファイルは見つからない [404]';
        } else if (jqXHR.status == 500) {
          msg += 'サーバーエラー [500]';
        } else if (exception === 'parsererror') {
          msg += 'JSONの読み込みが失敗';
        } else if (exception === 'timeout') {
          msg += 'タイムアウト';
        } else if (exception === 'abort') {
          msg += 'AJAXは突然終了しちゃった';
        } else {
          msg += '原因は不明なエラー\n' + jqXHR.responseText;
        }
        console.warn(msg);
      },
    })
  } // if home

  if ($hiddenItems.length > 0) {
    $hiddenItems.slice(0, revealCount).each(function(index, hiddenItem) { // 最初の二つの要素（slice(0,2)）を選択し、
      $(hiddenItem).removeClass(function(index, className) { // 単位項目にremoveClassのカスタム関数を実行し
        return className.match(/\S+--hidden/g); // 「--hidden」が入っているクラスを削除する
      })
    });
    
    // if (tabby) tabby.updateSliderHeight();
    
  } else if ($hiddenItems.length <= 0 && !$('body').hasClass('home')) {
    $clickedButton.css('opacity', '0');
  }
} // end loadItemSets()
